import { cn } from '@repo/ui/lib/utils'
import { LucideIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { HStack, Spread, Surface, Text } from './Atoms'
import { SurfaceProps } from './Atoms/Layout/Surface'

type NoteProps = SurfaceProps & {
  note: ReactNode
  icon?: LucideIcon
  action?: ReactNode
}

export function Note(props: NoteProps) {
  return (
    <Surface
      tone={props.tone}
      padding="sm"
      as={props.as}
      border={props.border}
      interactive={props.interactive}
      radius="md"
      className={cn('w-full', props.className)}
    >
      <Spread align="center">
        <HStack gap="sm" align="center">
          {props.icon && <props.icon className="ml-1 size-4 shrink-0" />}
          {typeof props.note === 'string' ? (
            <Text className="text-pretty">{props.note}</Text>
          ) : (
            props.note
          )}
        </HStack>

        {props.action}
      </Spread>
    </Surface>
  )
}
